<template>
  <div v-if="!isWX">
    <h3>会员服务需要微信登录</h3>
    <h3>请在微信内打开页面</h3>
    <div style="position: absolute; bottom: 0; text-align: center; width: 90%; padding: 5px">
      <a href="https://beian.miit.gov.cn/">{{beian_code}}</a>
    </div>
  </div>
  <div v-else>
    <div v-if="initializing" class="content">
      <wv-cell>
        <wv-spinner type="default"></wv-spinner>
      </wv-cell>
    </div>
    <div v-else>
      <van-nav-bar title="会员中心" fixed right-text="微信卡券" @click-right="openVoucherCards"/>

      <div v-if="mobileBind" class="content">
        <div class="vipCard" v-for="(item, index) in items">
          <div class="card_top">
            <div class="card_number">
              <span>{{item.card_number}}</span>
            </div>
            <span style="font-size:13px">{{item.get_member_card_type_display}}</span>
          </div>
          <div v-if="item.often_use">
            <van-cell :border="false">
              <!-- 使用插槽来自定义 -->
              <template #title>
                <span>{{item.type}}<van-tag class="ml" type="warning" v-if="item.discount<100">{{item.discount/10+'折'}}</van-tag></span>
              </template>
              <template #default>
                <span class="card_number">余额 <span style="color:#F56C6C">￥{{item.deposit_amount}}</span></span>
              </template>
            </van-cell>
            <!-- 次卡 -->
            <van-cell :border="false" v-for="(cika_item, index) in item.cika_entries" :key="index + 1" class="s_card">
              <template #title>
                <span>{{cika_item.service_name}}<span class="ml">{{Math.round(cika_item.count)}}次</span></span>
              </template>
              <template #default>
                <span v-if="cika_item.used_count<0.5">未使用</span>
                <span v-else>已用{{Math.round(cika_item.used_count)}}次</span>
              </template>
            </van-cell>
            <!-- 赠卡 -->
            <van-cell :border="false" v-for="(bonus_item, index) in item.bonus_items" :key="index + 1" class="s_card">
              <template #title>
                <span>赠卡{{bonus_item.sequence}}<span class="ml" v-if="bonus_item.shop_name">【限{{bonus_item.shop_name}}】</span></span>
              </template>
              <template #default>
                <span>￥{{bonus_item.amount}}</span>
              </template>
            </van-cell>
            <van-cell :title="item.assign_type" is-link value="查看消费记录" :border="false" @click="handleTo(item)" />
          </div>
          <div style="text-align:end;font-size:14px" v-else>
            <span @click="changeOftenUse(item)">
              <van-tag class="ml" type="warning">点击查看</van-tag>
            </span>
          </div>
        </div>
        <p v-if="loaded && items.length === 0" style="margin: 150px auto; text-align:center">
          您的手机号没有关联的会员
        </p>
        <wv-button type="default" @click="removeBind()">解除绑定</wv-button>
      </div>
      <div v-else class="content">
        <van-nav-bar title="绑定会员" fixed />
        <div class="main">
          <wv-input label="手机号" placeholder="绑定手机号" type="number" v-model="tel" pattern="^((13|14|15|17|18)[0-9]{1}\d{8})$"></wv-input>
          <wv-input label="验证码" placeholder="输入验证码" type="number" v-model="verify_code">
            <button class="weui-vcode-btn" slot="ft" v-if="show" @click="getCode">获取验证码</button>
            <button class="weui-vcode-btn" style="color: gray" slot="ft" v-else>{{ count }}s重新获取</button>
          </wv-input>
          <p style="padding:30px">
            <wv-button type="primary" @click="handleBind">绑定会员</wv-button>
          </p>
          <p>初次使用请填写会员卡关联手机号</p>
          <p>验证后可以自动获取您的会员信息</p>
        </div>
      </div>
    </div>
    <div style="margin-top: 10px; width: 90%; padding: 5px">
      <a href="http://beian.miit.gov.cn/">{{ beian_code }}</a>
    </div>
  </div>
</template>
<script>
import { Toast } from 'we-vue'
import { login, sendSms, bindMobile, checkBindRequest, jssdkConfig, jssdkCardConfig, decrpytCard } from '@/api/login'
import { setOpenid, getOpenid } from '@/utils/auth'
import { bindOpenIdToRequest } from '@/utils/request'
import { getMember, removeBindRequest } from '@/api/login'
import { removeOpenid } from '@/utils/auth'
import wx from 'weixin-js-sdk'

export default {
  name: 'index',
  redirectUrl: null,
  data() {
    return {
      beian_code: process.env.BEIAN_CODE,
      show: true,
      count: '',
      tel: null,
      verify_code: null,
      mobileBind: null,
      initializing: true,
      isWX: false,
      // 是否固定nav_bar
      fixed: true,
      // 从member页移过来的
      items: [],
      loaded: false,
      // tabbar idx
      active: 0
    }
  },
  created() {
    this.isWX = this.isWeixin();
    if (this.isWX) {
      this.fetchOpenId();
      this.configJsSDK();
    }
  },
  methods: {
    handleBind() {
      let obj = {}
      obj.mobile = this.tel
      obj.verify_code = this.verify_code
      bindMobile(obj).then(res => {
        this.checkBind();
      })
    },
    fetchOpenId() {
      let openId = getOpenid();
      if (!openId) {
        login(this.getQueryParams('code'), this.getQueryParams('state')).then(response => {
          openId = response.openid;
          setOpenid(openId)
        });
      }
      bindOpenIdToRequest();
      this.checkBind();
    },
    checkBind() {
      checkBindRequest().then(res => {
        this.mobileBind = res.bind;
        this.initializing = false;
        if (this.mobileBind) {
          this.fetchData()
        }
      })
    },
    getQueryParams(name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURI(r[2]);
      }
      return null;
    },

    startCountDown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
      }
    },

    //发送验证码
    getCode() {
      if (this.tel == null) {
        Toast({
          duration: 3000,
          message: '请输入手机号',
          type: 'text'
        })
      } else {

        let obj = {}
        obj.mobile = this.tel
        sendSms(obj).then(res => {
          this.startCountDown();
          Toast({
            duration: 3000,
            message: '验证码已发送',
            type: 'text'
          });
        })
      }
    },

    // 从member页移过来的
    fetchData() {
      getMember().then(res => {
        this.items = res;
        this.loaded = true;
      })
    },
    handleTo(item) {
      this.$router.push({ name: 'expense', query: { id: item.uuid } })
    },
    toTickets() {
       this.$router.push({ name: 'tickets'})
    },
    removeBind() {
      removeBindRequest().then(res => {
        removeOpenid();
        window.location.href = res.redirect_url
      })
    },
    changeOftenUse(item) {
      item.often_use = true
    },
    isWeixin() {
      return window.navigator.userAgent.toLowerCase().indexOf("micromessenger") >= 0;
    },
    configJsSDK(){
      let url = location.href.split('#')[0]
      jssdkConfig(url).then(res => {
        wx.config({
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          // debug:true,
          jsApiList: ['chooseCard', 'openCard']
        })
      })
      .catch(function(error) {
        console.log(error);
      })
    },
    openVoucherCards(){
      let url = location.href.split('#')[0]
      jssdkCardConfig(url).then(res => {
        wx.chooseCard({
          timestamp: res.timestamp, // 卡券签名时间戳
          nonceStr: res.nonceStr, // 卡券签名随机串
          signType: 'SHA1', // 签名方式，默认'SHA1'
          cardSign: res.signature, // 卡券签名
          success: function(res) {
            let card = JSON.parse(res.cardList)[0] // 狗屎微信，返回string
            console.log('first card:')
            console.log(card)
            decrpytCard(card.encrypt_code).then(res => {
              wx.openCard({
                cardList: [{ cardId: card.card_id, code: res.code }],
                success: function(openRes) {
                  console.log(openRes)
                }
              })
            })

          },
          fail: function(res) {
            console.log(res)
          }
        })
      })
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  padding: 50px 0px;
  text-align: center;
}

.vipCard {
  margin: 0 2px 20px 2px;
  padding: 20px;
  background-color: #fff;
  /*background: linear-gradient(to top, rgb(210, 210, 210) 50%, rgb(133, 133, 133));
  background: linear-gradient(to top, rgb(210, 210, 210) 50%, rgb(133, 133, 133));*/
  /*background: linear-gradient(to top, rgb(235, 215, 136) 50%, rgb(198, 166, 65));*/
  border-radius: 20px;
  border: 0 1px dashed #D98719;
}

.ml {
  margin-left: 6px;
}

.card_number {
  font-size: 15px;
  color: #2c3e50;
}
/deep/ .van-nav-bar__text {
    color: #61805f;
    margin-right: 4px;
}
.card_top {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px 10px;
  border-bottom: 5px dashed #eee;
}

.van-cell {
  background-color: transparent;
  padding: 10px 10px;
}

.s_card .van-cell__value {
  color: rgb(102, 102, 102);
}

.s_card .van-cell__title {
  flex: 3;
  color: #969799;
}

.content {
  text-align: left;
  padding: 10px;

}

.left {
  float: left;
}

</style>



// WEBPACK FOOTER //
// src/components/index.vue